module.exports = __webpack_public_path__ + "img/craftBannerGarage.d261089.webp";